import { BASE_URL } from './Config.js';

export class TVAService {
  createTVA = async (tvaData) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/tva/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(tvaData)
      });

      if (!response.ok) {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Erreur lors de la création');
        }
        throw new Error(await response.text() || 'Erreur serveur');
      }
      return await response.json();
    } catch (error) { console.error('Error creating TVA:', error); throw error; }
  };

  getAllTVA = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/tva/all`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Failed to fetch TVA');
      return await response.json();
    } catch (error) { console.error('Error fetching TVA:', error); throw error; }
  };

  getTVAById = async (id) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/tva/${id}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Failed to fetch TVA');
      return await response.json();
    } catch (error) { console.error('Error fetching TVA:', error); throw error; }
  };

  updateTVA = async (id, tvaData) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/tva/update/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(tvaData)
      });

      if (!response.ok) {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Erreur lors de la mise à jour');
        }
        throw new Error(await response.text() || 'Erreur serveur');
      }
      return await response.json();
    } catch (error) { console.error('Error updating TVA:', error); throw error; }
  };

  deleteTVA = async (id) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/tva/delete/${id}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Failed to delete TVA');
      return true;
    } catch (error) { console.error('Error deleting TVA:', error); throw error; }
  };

    deleteAllTVA = async () => {
    const token = localStorage.getItem('accessToken');
    const res = await fetch(`${BASE_URL}/tva/delete-all`, {
      method: 'DELETE',
      headers: { 
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` 
      }
    });
    
    if (!res.ok) {
      throw new Error(await res.text() || 'Erreur lors de la suppression globale');
    }
    
    // 🟢 Gestion robuste (Texte brut ou JSON)
    const rawText = await res.text(); 
    try {
      return JSON.parse(rawText); 
    } catch (e) {
      return { success: true, message: rawText };
    }
  };
}